import { useState } from "react";
import { useParams } from "react-router";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import { handleErrorMessage, useEffectOnce } from "../../../utils/Utils";

interface UploadRevisionServiceType {
  article: any;
}

export default function UploadRevisionService(): UploadRevisionServiceType {
  const { axiosGetArticleById }: ArticleControllerType = ArticleController();

  const { showMessage } = useAppContext();
  const { id }: any = useParams();
  const [article, setArticle] = useState<any>({});

  useEffectOnce(() => {
    getArticle();
  });

  const getArticle = () => {
    axiosGetArticleById(id)
      .then((res: any) => {
        setArticle(res.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return {
    article,
  };
}

export type { UploadRevisionServiceType };
